import { useState, useCallback } from 'react';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import type { ActivateCardPayload } from '@/features/onboarding/types/onboarding.types';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';

export const useActivateCard = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const activateCard = useCallback(async (payload: ActivateCardPayload): Promise<boolean> => {
        show();
        setError(null);
        try {
            await onboardingService.activateCard(payload);
            return true;
        } catch (err) {
            setError(t('onboarding.activateCard.errors.generic'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return {
        activateCard,
        isLoading: isSpinnerLoading,
        error
    };
};
